import * as Yup from 'yup';
import { FIELDS_CONFIG } from './constants';

/**
 * Generates a Yup validation schema based on the provided data.
 * @param {Object} data - The data used to generate the validation schema.
 * @param {boolean} showAreaFeature - Whether the area selector is shown and required.
 * @returns {Yup.ObjectSchema} The Yup validation schema.
 */
const validationSchema = (data, showAreaFeature = false) =>
  Yup.object().shape(
    FIELDS_CONFIG(data, 0, showAreaFeature).reduce((accumulator, { name, validation }) => {
      accumulator[name] = validation;
      return accumulator;
    }, {})
  );

export default validationSchema;
